<div class="card">
  <p-table #drivertable [value]="drivers" scrollable="true" scrollHeight="70vh" dataKey="driver_id" editMode="row"
    [tableStyle]="{ 'min-width': '50rem' }" selectionMode="single" [(selection)]="selectedDriver" [paginator]="true"
    [rows]="50" [rowHover]="true" [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} drivers"
    [globalFilterFields]="['first_name', 'last_name', 'truck_number', 'trailer_number']">
    <ng-template pTemplate="caption">
      <div class="flex justify-content-center align-items-center p-3">
        <div class="flex-none w-1"></div>
        <div class="flex-grow-1 flex justify-content-center align-items-center gap-3">
          <span class="p-input-icon-left w-full md:w-25rem">
            <i class="pi pi-times cursor-pointer" (click)="clear(drivertable)"></i>
            <input class="custom-search" pInputText #searchInput type="text" placeholder="Search..."
              (input)="drivertable.filterGlobal($any($event.target).value, 'contains')" class="w-full p-3"
              [style]="{'border-radius': '12px', 'border': '1px solid var(--surface-300)', 'width':'300px', 'height': '4px'}" />
          </span>
        </div>
        <div class="flex-none">
          <div *ngIf="isAdmin">
            <button pButton icon="pi pi-plus" label="Add New Driver" [raised]="true" severity="info"
              (click)="newDriverDialog()" [outlined]="true"></button>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="first_name">Driver <p-sortIcon field="first_name" /></th>
        <th pSortableColumn="truck_number">Truck # <p-sortIcon field="truck_number" /></th>
        <th pSortableColumn="trailer_number">Trailer # <p-sortIcon field="trailer_number" /></th>
        <th pSortableColumn="type">Type <p-sortIcon field="type" /></th>
        <th>Notes</th>
        <th></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-driver let-editing="editing" let-ri="rowIndex">
      <tr [pEditableRow]="driver">
        <td>
          {{ driver.first_name }} {{ driver.last_name }}
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-dropdown [options]="trucks" [(ngModel)]="driver.truck_id"
                (onChange)="onTruckChange($event, driver)" [placeholder]="driver.truck_number || 'Select Truck'"
                optionLabel="truck_number" optionValue="truck_id" class="w-full" appendTo="body" [filter]="true"
                [filterBy]="'truck_number'" [filterMatchMode]="'contains'" [filterFields]="['truck_number']"
                [showClear]="true"></p-dropdown>
            </ng-template>
            <ng-template pTemplate="output">
              {{ driver.truck_number }}
            </ng-template>
          </p-cellEditor>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-dropdown [options]="trailers" [(ngModel)]="driver.trailer_id"
                (onChange)="onTrailerChange($event, driver)" [placeholder]="driver.trailer_number || 'Select Trailer'"
                optionLabel="trailer_number" optionValue="trailer_id" class="w-full" appendTo="body" [filter]="true"
                [filterBy]="'trailer_number'" [filterMatchMode]="'contains'" [filterFields]="['trailer_number']"
                [showClear]="true"></p-dropdown>
            </ng-template>
            <ng-template pTemplate="output">
              {{ driver.trailer_number }}
            </ng-template>
          </p-cellEditor>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-dropdown [options]="types" [(ngModel)]="driver.type" [placeholder]="driver.type || 'Select Type'"
                optionLabel="label" optionValue="value" class="w-full" appendTo="body" [showClear]="true"></p-dropdown>
            </ng-template>
            <ng-template pTemplate="output">
              {{ driver.type }}
            </ng-template>
          </p-cellEditor>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" [(ngModel)]="driver.notes" class="w-full"
                (onChange)="onNotesChange($event, driver)">
            </ng-template>
            <ng-template pTemplate="output">
              {{ driver.notes }}
            </ng-template>
          </p-cellEditor>
        </td>

        <td>
          <div class="flex align-items-center justify-content-center gap-2">
            <button *ngIf="!editing && hasAccess" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
              (click)="onRowEditInit(driver)" class="p-button-rounded p-button-text"></button>
            <button *ngIf="editing && hasAccess" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
              (click)="onRowEditSave(driver)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
            <button *ngIf="editing && hasAccess" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
              (click)="onRowEditCancel(driver)" class="p-button-rounded p-button-text p-button-danger"></button>
            <button *ngIf="isAdmin && !editing && hasAccess" pButton pRipple type="button" rounded="true" text="true"
              severity="danger" icon="pi pi-trash" (click)="removeDriver(driver)"></button>
            <p-button *ngIf="!editing" type="button" icon="pi pi-calendar" rounded="true" text="true" severity="info"
              (click)="showDialog(driver)"></p-button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>


  <p-confirmDialog header="Assignment Conflict" icon="pi pi-exclamation-triangle"></p-confirmDialog>
  <p-toast></p-toast>


  <p-dialog header="Add New Driver" [(visible)]="newDriverDialogVisible" [modal]="true" [closable]="true"
    [style]="{'width':'600px'}" [resizable]="false" (onHide)="resetNewDriverForm()">
    <p-divider></p-divider>
    <ng-template pTemplate="body">
      <div class="flex flex-column gap-4 pt-2">
        <div class="flex flex gap-3 justify-content-between align-items-center">
          <div class="flex flex-grow-1 flex-column gap-1 align-items-center">
            <label for="first_name">First Name</label>
            <input pInputText id="first_name" [(ngModel)]="newDriver.first_name" [style]="{'width':'100%'}"
              class="w-full">
          </div>
          <div class="flex flex-grow-1 flex-column gap-1 align-items-center">
            <label for="last_name">Last Name</label>
            <input pInputText id="last_name" [(ngModel)]="newDriver.last_name" [style]="{'width':'100%'}"
              class="w-full">
          </div>
        </div>
        <div class="flex gap-3 justify-content-between align-items-center">
          <div class="flex flex-grow-1 flex-column gap-1 align-items-center">
            <label for="truck_number">Truck Number</label>
            <p-dropdown [options]="trucks" [(ngModel)]="newDriver.truck_id" optionLabel="truck_number" optionValue="truck_id"
              appendTo="body" [style]="{'width':'175px'}" (onChange)="onTruckChange($event, newDriver)"
              [showClear]="true"></p-dropdown>
          </div>
          <div class="flex flex-grow-1 flex-column gap-1 align-items-center">
            <label for="trailer_number">Trailer Number</label>
            <p-dropdown [options]="trailers" [(ngModel)]="newDriver.trailer_id" optionLabel="trailer_number" optionValue="trailer_id"
              appendTo="body" [style]="{'width':'175px'}" (onChange)="onTrailerChange($event, newDriver)"
              [showClear]="true"></p-dropdown>
          </div>

          <div class="flex flex-grow-1 flex-column gap-1 align-items-center">
            <label for="type">Type</label>
            <p-dropdown [options]="types" [(ngModel)]="newDriver.type" optionLabel="label" optionValue="value" appendTo="body"
              [style]="{'width':'170px'}" [showClear]="true"></p-dropdown>
          </div>
        </div>

        <div class="flex flex-grow-1 flex-column gap-1 align-items-center">
          <label for="notes">Notes</label>
          <textarea pInputTextarea id="notes" [(ngModel)]="newDriver.notes" [rows]="3" class="w-full"
            [style]="{'width':'700px', 'height':'50px'}"></textarea>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="footer">
      <p-divider></p-divider>
      <div class="flex justify-content-end gap-3">
        <button pButton label="Cancel" (click)="resetNewDriverForm()" [outlined]="true"></button>
        <button pButton label="Save" (click)="saveNewDriver()" [raised]="true" [severity]="'info'"
          [disabled]="!newDriver.first_name || !newDriver.last_name || saving"
          [loading]="saving">
        </button>
      </div>
    </ng-template>
  </p-dialog>